import { pullQuotes, storyMeta } from '@/content/my-story';
import { assetUrl } from '@/lib/asset-url';

/**
 * Editorial opening banner for `/my-story`.
 * Magazine-style: portrait right, narrative copy left, integrated pull quote.
 */
export function StoryBanner() {
  return (
    <header className="relative overflow-hidden px-4 pt-16 pb-12 sm:px-6 sm:pt-24 sm:pb-16 lg:px-8">
      {/* Soft accent wash */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(ellipse_60%_40%_at_75%_5%,rgba(10,122,147,0.07),transparent_60%)]"
      />

      <div className="mx-auto grid w-full max-w-5xl items-start gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,0.85fr)] lg:gap-14">
        {/* Left: identity + lead quote */}
        <div className="flex flex-col items-start text-left">
          <div className="bg-primary/10 text-primary mb-6 inline-flex items-center rounded-full px-4 py-1.5 text-xs font-medium tracking-[0.18em] uppercase">
            {storyMeta.eyebrow}
          </div>

          <h1 className="font-display text-foreground text-4xl font-semibold tracking-tight text-balance sm:text-5xl lg:text-6xl">
            {storyMeta.title}
          </h1>

          <div className="mt-5 flex flex-col gap-1">
            <p className="text-foreground text-lg font-semibold sm:text-xl">{storyMeta.name}</p>
            <p className="text-muted-foreground text-sm font-medium sm:text-base">
              {storyMeta.role}
            </p>
            <p className="text-muted-foreground/70 text-xs sm:text-sm">{storyMeta.bioLine}</p>
          </div>

          <blockquote className="mt-10 max-w-lg">
            <p className="font-display text-foreground/90 text-xl leading-snug font-medium text-balance sm:text-2xl md:leading-snug lg:text-[1.7rem]">
              &ldquo;{pullQuotes.loveStory}&rdquo;
            </p>
            <footer className="text-muted-foreground mt-5 text-sm font-medium">
              &mdash; {storyMeta.name}
            </footer>
          </blockquote>
        </div>

        {/* Right: portrait */}
        <figure className="border-border/50 bg-card relative overflow-hidden rounded-2xl border shadow-[0_24px_64px_-32px_rgba(10,122,147,0.4)] lg:sticky lg:top-24">
          <img
            src={assetUrl(storyMeta.portraitSrc)}
            alt={storyMeta.portraitAlt}
            width={1168}
            height={1772}
            className="block h-auto w-full object-cover"
            decoding="async"
            fetchPriority="high"
          />
        </figure>
      </div>
    </header>
  );
}
